export default __webpack_public_path__ + "media/zurb/img/about/culture/culture-img5-0820d3f497bcfbf17651a7e3a0f4c2f0.jpg";